import { useEffect } from "react";
import LeeSummitHeroSection from "./components/HeroSection";
import LeeSummitStickyNav from "./components/StickyNav";
import LeeSummitProcessingTimeSection from "./components/ProcessingTimeSection";
import LeeSummitServicesSection from "./components/ServicesSection";
import LeeSummitLocalAreaSection from "./components/LocalAreaSection";
import LeeSummitDestinationsSection from "./components/DestinationsSection";
import LeeSummitTestimonialsSection from "./components/TestimonialsSection";
import LeeSummitAcceptanceFacilitiesSection from "./components/AcceptanceFacilitiesSection";
import LeeSummitComparisonSection from "./components/ComparisonSection";
import LeeSummitMistakesSection from "./components/MistakesSection";
import LeeSummitHowItWorksSection from "./components/HowItWorksSection";
import LeeSummitFAQSection, { faqs } from "./components/FAQSection";
import LeeSummitHelpfulResourcesSection from "./components/HelpfulResourcesSection";
import LeeSummitFinalCTA from "./components/FinalCTA";
import SEOCrossLinks from "@/components/feature/SEOCrossLinks";

export default function LeeSummitPage() {
  useEffect(() => {
    document.title = "Emergency Passport Lee's Summit, MO — Expedited Same-Day Service | Fast Passport Center";

    const setMeta = (name: string, content: string) => {
      let el = document.querySelector(`meta[name="${name}"]`);
      if (!el) {
        el = document.createElement("meta");
        el.setAttribute("name", name);
        document.head.appendChild(el);
      }
      el.setAttribute("content", content);
    };
    const setLink = (rel: string, href: string) => {
      let el = document.querySelector(`link[rel="${rel}"]`);
      if (!el) {
        el = document.createElement("link");
        el.setAttribute("rel", rel);
        document.head.appendChild(el);
      }
      el.setAttribute("href", href);
    };

    const pageUrl = "https://fastpassportcenter.com/lees-summit/";

    setLink("canonical", pageUrl);
    setMeta("description", "Emergency and expedited passport services in Lee's Summit, MO — as fast as 24 hours. No appointment scramble at the KC agency. A+ BBB rated, registered State Dept. courier serving Jackson County business travelers, Longview CC students, and families in Lee's Summit, Blue Springs, Grain Valley, and Raytown.");
    setMeta("geo.placename", "Lee's Summit, Missouri");
    setMeta("geo.region", "US-MO");
    setMeta("geo.position", "38.9108;-94.3827");
    setMeta("ICBM", "38.9108, -94.3827");

    const graph = [
      {
        "@type": "BreadcrumbList",
        itemListElement: [
          { "@type": "ListItem", position: 1, name: "Home", item: "https://fastpassportcenter.com/" },
          { "@type": "ListItem", position: 2, name: "Missouri", item: "https://fastpassportcenter.com/missouri/" },
          { "@type": "ListItem", position: 3, name: "Lee's Summit Passport Services", item: pageUrl },
        ],
      },
      {
        "@type": "LocalBusiness",
        name: "Fast Passport Center",
        description: "Fast Passport Center provides emergency and expedited passport services for Lee's Summit and the Jackson County area. As fast as 24 hours — no KC agency appointment scramble required.",
        url: pageUrl,
        telephone: "+1-877-253-0084",
        areaServed: { "@type": "City", name: "Lee's Summit", containedInPlace: { "@type": "State", name: "Missouri" } },
        priceRange: "$$$",
        openingHours: ["Mo-Fr 09:00-18:00"],
        aggregateRating: { "@type": "AggregateRating", ratingValue: "4.9", reviewCount: "1200" },
      },
      {
        "@type": "FAQPage",
        mainEntity: faqs.map((faq) => ({
          "@type": "Question",
          name: faq.q,
          acceptedAnswer: { "@type": "Answer", text: faq.a },
        })),
      },
    ];

    const script = document.createElement("script");
    script.type = "application/ld+json";
    script.id = "structured-data-lees-summit";
    document.getElementById("structured-data-lees-summit")?.remove();
    script.textContent = JSON.stringify({ "@context": "https://schema.org", "@graph": graph });
    document.head.appendChild(script);

    return () => {
      document.getElementById("structured-data-lees-summit")?.remove();
      document.querySelector('link[rel="canonical"]')?.remove();
    };
  }, []);

  return (
    <div className="font-sans">
      <LeeSummitHeroSection />
      <LeeSummitStickyNav />
      <LeeSummitProcessingTimeSection />
      <LeeSummitServicesSection />
      <LeeSummitLocalAreaSection />
      <LeeSummitDestinationsSection />
      <LeeSummitTestimonialsSection />
      <LeeSummitAcceptanceFacilitiesSection />
      <LeeSummitComparisonSection />
      <LeeSummitMistakesSection />
      <LeeSummitHowItWorksSection />
      <LeeSummitFAQSection />
      <LeeSummitHelpfulResourcesSection />
      <SEOCrossLinks currentRoute="/cities/lees-summit" state="MO" />
      <LeeSummitFinalCTA />
    </div>
  );
}